export default "__VITE_ASSET__C1qJc9Zs__"